import { Component, OnInit } from '@angular/core';
import {marker as _} from '@colsen1991/ngx-translate-extract-marker';
import {AuthData} from '../../models/auth-status';
import {AuthService} from '../../services/auth.service';
import { filter } from 'rxjs';
import { filteredTab } from 'src/app/utils/menu.helper';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss'],
})
export class LeftMenuComponent  implements OnInit {
  displayedTab: any[];

  constructor(private readonly authService: AuthService) { }

  ngOnInit() {
    this.authService.authStatus.pipe(filter(status => status?.authDone)).subscribe((status) => {
        this.displayedTab = filteredTab(status);
    });
  }

}
